module.exports = __webpack_public_path__ + "img/ek.5dba91df.png";